import { Component, OnInit, Input } from "@angular/core";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { EdpModalService } from "@edp-components/edp-modal";
import { ExternalLinkService } from "@edp-directives/external-link/external-link.service";
import { environment } from "@edp-environments/environment";

@Component({
    selector: "edp-contact-modal",
    templateUrl: "./edp-contact-modal.component.html",
    styleUrls: ["./edp-contact-modal.component.scss"],
})
export class EdpContactModalComponent implements OnInit {
    @Input() public data: IModalData;
    public isApp = false;

    constructor(private edpModalService: EdpModalService, private externalLinkService: ExternalLinkService) {}

    ngOnInit() {
        this.isApp = environment.isApp;
        this.listenerClickContact();
    }

    private listenerClickContact(): void {
        setTimeout(() => {
            try {
                const contact = this.data.collection.telephoneHref;
                if (!contact) {
                    return;
                }
                const el = document.getElementsByClassName("edp-es-contact")[0];
                el.addEventListener("click", () => {
                    const hrefContact = `tel:${contact}`;
                    if (this.isApp) {
                        this.externalLinkService.externalLink(hrefContact);
                        return;
                    }
                    window.location.href = hrefContact;
                });
            } catch (error) {}
        }, 250);
    }

    public closeModal(): void {
        this.edpModalService.close(false);
    }
}
